import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/MarketingEmail.css';
import emailHero from "../../../assets/images/email.jpg";
import emailCampaign from "../../../assets/images/email.jpg";

const EmailMarketingPage = () => {
    return (
        <div className="email-container">
            <Helmet>
                <title>Email Marketing Services – BuddyTech Solutions</title>
                <meta name="description" content="Boost conversions with targeted email campaigns, newsletters, automation flows, and performance analytics." />
                <meta name="keywords" content="email marketing, newsletters, email automation, campaign design, lead nurturing, Mailchimp, HubSpot" />

                <meta property="og:title" content="Email Marketing Services – BuddyTech Solutions" />
                <meta property="og:description" content="Boost conversions with targeted email campaigns, newsletters, automation flows, and performance analytics." />
                <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
                <meta property="og:url" content="https://buddytechsolutions.in/services/marketing/email" />
                <meta property="og:type" content="website" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Email Marketing Services – BuddyTech Solutions" />
                <meta name="twitter:description" content="Boost conversions with targeted email campaigns, newsletters, automation flows, and performance analytics." />
                <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
            </Helmet>

            <header className="email-hero">
                <div className="email-hero-content">
                    <h1>Email Marketing Services</h1>
                    <p>
                        Build relationships, increase engagement, and convert leads through beautifully crafted, data-driven email marketing.
                    </p>
                </div>
                <img src={emailHero} alt="Email Hero" className="email-hero-img" />
            </header>

            <section className="email-section">
                <div className="email-text">
                    <h2>Our Email Marketing Solutions</h2>
                    <p>
                        We design and manage high-converting email campaigns that nurture your audience with personalized and targeted content.
                    </p>
                    <ul>
                        <li>Newsletter Design & Scheduling</li>
                        <li>Automation Flows & Drip Campaigns</li>
                        <li>Audience Segmentation & Personalization</li>
                        <li>A/B Testing & Performance Optimization</li>
                        <li>Campaign Tracking & Analytics</li>
                    </ul>
                </div>
                <img src={emailCampaign} alt="Email Campaign" className="email-img" />
            </section>

            <section className="email-tools">
                <h2>Tools & Platforms</h2>
                <div className="tools-grid">
                    <span>Mailchimp</span>
                    <span>Sendinblue</span>
                    <span>HubSpot</span>
                    <span>MailerLite</span>
                    <span>ConvertKit</span>
                    <span>Zoho Campaigns</span>
                    <span>Klaviyo</span>
                    <span>ActiveCampaign</span>
                </div>
            </section>
            <section className="contact-options">
                <div className="contact-card email">
                    <h2>📧 Email</h2>
                    <p>Send us an email for inquiries, support or collaboration opportunities.</p>
                    <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
                        Send Email
                    </a>
                </div>

                <div className="contact-card whatsapp">
                    <h2>💬 WhatsApp</h2>
                    <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
                    <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
                        Chat on WhatsApp
                    </a>
                </div>

                <div className="contact-card phone">
                    <h2>📞 Call Us</h2>
                    <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
                    <a href="tel:+919842084312">Call Us</a>
                </div>
            </section>
        </div>
    );
};

export default EmailMarketingPage;
